import { createSlice } from "@reduxjs/toolkit";
import { getStaffList } from "../../api/staff";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getStaffSlice = createSlice({
  name: "getStaff",
  initialState: data,
  reducers: {
   getStaffSlice(state) {
      state.isLoading = true;
    },
   getStaffSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getStaffSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getStaffSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const getStaffHandler = (search: string, role_id: string,sortField:any,sortDirection:any) => async (dispatch: any) => {
  try {
    dispatch(getStaffAction.getStaffSlice());
    const response: any = await getStaffList(search, role_id,sortField,sortDirection);
    
    dispatch(getStaffAction.getStaffSliceSuccess(response));
  } catch (e: any) {
    dispatch(getStaffAction.getStaffSliceFailure(e?.response?.data));
  }
};

export default getStaffSlice.reducer;
export const getStaffAction = getStaffSlice.actions;